<template>
  <div v-if="lodging">
    <div>
      <label class="label-calculators">
        <img :src="lodging.icon" class="image-icon-mobile" />
        {{ lodging.type }}</label>
      <div class="d-flex vertical-center space-between wrap-mobile">
        <div class="col-20">
          <img :src="lodging.icon" class="image-icon" />
        </div>
        <div class="position-relative col-38">
          <input type="number" class="lodging-calculator-input w-100" placeholder="Temps passé dans l’hébergement"
            v-model="results['temps']" @input="$emit('update:modelValue', results)" min="0" />
          <div class="percent">%</div>
        </div>
        <div class="position-relative col-38" v-if="!lodging.onlyOne">
          <input type="number" class="lodging-calculator-input w-100" placeholder="Nombre de chambres occupées"
            v-model="results['nbChambre']" @input="$emit('update:modelValue', results)" min="0" />
        </div>
        <div v-else class="col-38">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      results: {
        temps: null,
        nbChambre: null
      },
    }
  },
  props: {
    lodging: Object,
    modelValue: Object
  },
  watch: {
    modelValue(newVal) {
      this.results = newVal;
    }
  },
  mounted() {
    this.results.factor = this.lodging.factor
  }
}
</script>
<style scoped>
.col-38 {
  width: 39%;
}

.image-icon {
  width: 90%;
  margin-left:5%;
}

.lodging-calculator-input {
  display: flex;
  height: 57px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-right: 10px;
  border: 2px solid var(--Secondary-Noir, #3B3B3C);
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  text-align: start;
  box-sizing: border-box;
}

.lodging-calculator-input::placeholder {
  color: #bab1b1;
  font-family: var(--font);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.2px;
  /* 235% */
}

.percent {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-color);
  font-family: var(--font);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.2px;
  /* 141% */
}

.image-icon {
  max-width: 80px;
}

.image-icon-mobile {
  display: none
}

@media screen and (max-width: 1500px) {
  .col-20 {
    width: 20%;
  }

  .col-80 {
    width: 75%;
  }

  .label-calculators {
    font-size: 24px;
  }
}

@media screen and (max-width: 1300px) {
  .col-15 {
    width: 20%;
  }

  .col-80 {
    width: 80%;
  }
}

@media screen and (max-width: 900px) {
  .label-calculators {
    font-size: 20px;
  }

  .lodging-calculator-input::placeholder {
    font-size: 14px;
  }

  .percent {
    font-size: 14px;
    right: 10px;
  }

  .lodging-calculator-input {
    padding-left: 5px;
    padding-right: 20px;
  }

}

@media screen and (max-width: 750px) {
  .image-icon {
    display: none;
  }

  .image-icon-mobile {
    display: block;
    width:80px;
  }

  .label-calculators {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }

  .col-38 {
    width: 100%;
    margin-top: 20px;
  }

  .wrap-mobile {
    flex-wrap: wrap;
  }

  .label-calculators {
    font-size: 20px;
  }
}

@media screen and (max-width: 600px) {
  .distance-calculator-container h2 {
    font-size: 25px;
  }

  .distance-calculator-container {
    padding: 5px 10px;
  }

  .big-input-unit {
    font-size: 20px;
  }
}
</style>